import React from "react";
import AppButton from "./AppButton";

const ListToolbar = ({
  title,
  subtitle,
  addButton,
  children,
  filterBadges,
  className = "",
}) => {
  return (
    <div className={`list-toolbar-card ${className}`}>
      <div className="list-toolbar-top">
        <div className="list-toolbar-title">
          <h5>{title}</h5>
          {subtitle && <small>{subtitle}</small>}
        </div>
        {addButton && (
          <AppButton
            variant="primary"
            onClick={addButton.onClick}
            disabled={addButton.disabled || addButton.loading}
          >
            {addButton.loading ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              />
            ) : addButton.icon ? (
              <i className={`${addButton.icon} me-2`}></i>
            ) : (
              <i className="fas fa-plus me-2"></i>
            )}
            {addButton.label}
          </AppButton>
        )}
      </div>
      {children && <div className="list-toolbar-filters">{children}</div>}
      {filterBadges && (
        <div className="list-toolbar-badges">{filterBadges}</div>
      )}
    </div>
  );
};

export default ListToolbar;
